module.exports = __webpack_public_path__ + "img/logo-icon-aha.3d9ceb7a.svg";